const PageHeaderTitle = ({ children, testid }) => {
  return (
    <div
      data-cy={testid}
      className=' font-[roboto] text-xl font-bold sm:text-2xl md:text-3xl'
    >
      {children}
    </div>
  );
};

export default PageHeaderTitle;
